import React, { useState } from 'react';
import { List, message, Tag } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import { FormItemInputStyled } from '../Styled/GlobalStyles';

interface Props {
  onChange: (values: string[]) => void;
}

const BillOfLadingInput: React.FC<Props> = ({ onChange }) => {
  const [inputValue, setInputValue] = useState('');
  const [userAddedValue, setUserAddedValue] = useState<boolean>(false);
  const [billOfLadingNumbers, setBillOfLadingNumbers] = useState<string[]>([]);
  const [isInputValid, setIsInputValid] = useState<boolean>(true);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const addBillOfLadingFromInput = (value: string) => {
    let existingNumbers = billOfLadingNumbers;
    if (!userAddedValue) {
      existingNumbers = [];
      setUserAddedValue(true);
    }
    if (existingNumbers.includes(value)) {
      message.warning('Bill of lading already added!');
    } else if (value.includes(',')) {
      const values = value
        .split(',')
        .filter((i) => i)
        .map((value) => value.trim());
      setBillOfLadingNumbers([...existingNumbers, ...values]);
      setInputValue('');
    } else if (value.includes(' ')) {
      const values = value
        .split(' ')
        .filter((i) => i)
        .map((value) => value.trim());
      setBillOfLadingNumbers([...existingNumbers, ...values]);
      setInputValue('');
    } else {
      setBillOfLadingNumbers([...existingNumbers, value]);
      setInputValue('');
    }
  };

  const handleRemoveChip = (billOfLadingNumber: string) => {
    setBillOfLadingNumbers(billOfLadingNumbers.filter((bol) => bol !== billOfLadingNumber));
  };

  const handleKeyPress = (e: any) => {
    console.log('Key press detected');
    const isEnter = e.key === 'Enter';
    if (isEnter) e.preventDefault();
    setInputValue(e.target.value);

    if (!userAddedValue && !isEnter) {
      setTimeout(() => {
        if (!e.target.value) {
          setBillOfLadingNumbers([]);
        } else {
          setBillOfLadingNumbers([e.target.value]);
        }
      }, 100);
    }

    if (inputValue.length > 4) {
      setIsInputValid(true);
    } else {
      setIsInputValid(false);
    }

    if (isEnter) {
      addBillOfLadingFromInput(inputValue);
    }
  };

  // Call the parent onChange function when the bill of lading numbers change
  React.useEffect(() => {
    onChange(billOfLadingNumbers);
  }, [billOfLadingNumbers, onChange]);

  return (
    <div>
      <FormItemInputStyled
        placeholder='Enter a bill of lading number'
        value={inputValue}
        onChange={handleKeyPress}
        onKeyPress={handleKeyPress}
        suffix={
          <PlusCircleOutlined
            onClick={isInputValid ? () => addBillOfLadingFromInput(inputValue) : () => {}}
            style={{ color: isInputValid ? '#1d39c4' : 'gray' }}
            disabled={!isInputValid}
          />
        }
        size={'large'}
        status={isInputValid ? '' : 'error'}
      />
      {billOfLadingNumbers.length > 0 && (
        <List
          style={{ marginTop: 20, maxWidth: 350 }}
          size='small'
          header={
            <div>
              {billOfLadingNumbers.length} Bill{billOfLadingNumbers.length == 1 ? '' : 's'} Of Lading will be released
            </div>
          }
          bordered
          dataSource={billOfLadingNumbers}
          renderItem={(bol) => (
            <List.Item>
              <Tag
                color='geekblue'
                key={bol}
                closable
                onClose={(e) => {
                  handleRemoveChip(bol);
                }}
              >
                {bol}
              </Tag>
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

export default BillOfLadingInput;
